import { useState, useContext, useEffect } from "react";
import { useLocation, Link, NavLink, useNavigate } from "react-router-dom";
// Combined React-Bootstrap imports
import { Navbar, Nav, Container, Offcanvas } from "react-bootstrap";
import "./Header.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { Dot_Lottie } from "../common/lotties/dot-lottie/Dot_Lottie";
import { PowerProgress } from "../../utils/apis/homepage";
import { IDS } from "../../utils/common";
import { Context } from "../../utils/context";

const Header = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [showMobileNav, setShowMobileNav] = useState(false);
  const { IMG_URL } = useContext(Context);
  const [appsetup, setAppSetup] = useState({});
  const location = useLocation();

  const getAppSetup = async () => {
    const res = await PowerProgress();
    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  const cleanContactNo = appsetup.contactno
    ? appsetup.contactno.replace(/\D/g, "")
    : "";

  // Handlers to control Offcanvas visibility
  const handleCloseMobile = () => setShowMobileNav(false);
  const handleOpenMobile = () => setShowMobileNav(true);

  return (
    <section className="header_section">
      <div className="desktop_header_holder">
        <div className="top-bar">
          <div className="top-bar-inner container">
            <div className="logo-wrapper" onClick={() => navigate("/")}>
              <img
                src={IDS?.IMG_URL + appsetup?.logo}
                alt="Diligencia"
                className="top-logo"
              />
            </div>
            <div className="top-contact">
              <div className="contact-item">
                <FontAwesomeIcon icon={faWhatsapp} />
                <div className="label">
                  <p>Contact Number:</p>
                  <a
                    href={
                      cleanContactNo ? `https://wa.me/${cleanContactNo}` : "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="value">
                      {appsetup.contactno || "Loading..."}
                    </p>
                  </a>
                </div>
              </div>
              <div className="divider" />
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <div className="label">
                  <p>Email:</p>
                  <a href={`mailto:${appsetup.email || ""}`}>
                    <p className="email">{appsetup.email || "Loading..."}</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="abs_div">
          <div className="container-fluid p-0">
            <Navbar
              expand="lg"
              className="main-navbar"
              collapseOnSelect
              expanded={expanded}
              onToggle={() => setExpanded(!expanded)}
            >
              <div className="container p-0">
                <Navbar.Toggle
                  aria-controls="basic-navbar-nav"
                  onClick={() => setExpanded(expanded ? false : "expanded")}
                />

                <Navbar.Collapse id="main-navbar-nav">
                  <Nav className="main-nav-links">
                    <Nav.Link
                      as={NavLink}
                      to="/"
                      onClick={() => setExpanded(false)}
                    >
                      Home
                    </Nav.Link>
                    <Nav.Link
                      as={NavLink}
                      to="/about-us"
                      onClick={() => setExpanded(false)}
                    >
                      About us
                    </Nav.Link>
                    <Nav.Link
                      as={NavLink}
                      to="/services"
                      onClick={() => setExpanded(false)}
                    >
                      Service
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/gallery"
                      onClick={() => setExpanded(false)}
                      className={`nav-link ${
                        location.pathname.startsWith("/gallery") ? "active" : ""
                      }`}
                    >
                      Gallery
                    </Nav.Link>
                    <Nav.Link
                      as={NavLink}
                      to="/blog"
                      onClick={() => setExpanded(false)}
                    >
                      Blog
                    </Nav.Link>
                    <Nav.Link
                      as={NavLink}
                      to="/career"
                      onClick={() => setExpanded(false)}
                    >
                      Career
                    </Nav.Link>
                    <Nav.Link
                      as={NavLink}
                      to="/contact-us"
                      onClick={() => setExpanded(false)}
                    >
                      Contact Us
                    </Nav.Link>
                    <Nav.Link
                      as={NavLink}
                      to="/faq"
                      onClick={() => setExpanded(false)}
                    >
                      FAQ
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </div>
        </div>
      </div>

      {/* MOBILE HEADER */}
      <div className="mobile_view_header">
        <Navbar expand="lg" className="bg-body-tertiary mb-3">
          <Container fluid>
            <Navbar.Brand
              onClick={() => {
                navigate("/");
                handleCloseMobile();
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src={IDS?.IMG_URL + appsetup?.logo}
                alt="Diligencia"
                style={{ maxHeight: "40px" }}
              />
            </Navbar.Brand>

            <Navbar.Toggle
              aria-controls="offcanvasNavbar-mobile"
              onClick={handleOpenMobile}
            />

            <Navbar.Offcanvas
              placement="start"
              onHide={handleCloseMobile}
              className="mobile_offcanvas"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel-mobile">
                  <Navbar.Brand
                    onClick={() => {
                      navigate("/");
                      handleCloseMobile();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={IDS?.IMG_URL + appsetup?.logo}
                      alt="Diligencia"
                      style={{ maxHeight: "40px" }}
                    />
                  </Navbar.Brand>
                </Offcanvas.Title>
              </Offcanvas.Header>

              <Offcanvas.Body>
                {/* Added mobile-nav-links container context */}
                <Nav className=" mobile-nav-links">
                  <Nav.Link as={NavLink} to="/" onClick={handleCloseMobile}>
                    Home
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/about-us"
                    onClick={handleCloseMobile}
                  >
                    About us
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/services"
                    onClick={handleCloseMobile}
                  >
                    Service
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/gallery"
                    onClick={handleCloseMobile}
                  >
                    Gallery
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/blog" onClick={handleCloseMobile}>
                    Blog
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/career"
                    onClick={handleCloseMobile}
                  >
                    Career
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/contact-us"
                    onClick={handleCloseMobile}
                  >
                    Contact Us
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/faq" onClick={handleCloseMobile}>
                    FAQ
                  </Nav.Link>
                </Nav>

                {/* Contact Details context below */}
                <div className="mobile-sidebar-contact">
                  {appsetup.contactno && (
                    <div className="mb-2">
                      <a
                        href={
                          cleanContactNo
                            ? `https://wa.me/${cleanContactNo}`
                            : "#"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact_text"
                        onClick={handleCloseMobile}
                      >
                        <FontAwesomeIcon
                          icon={faWhatsapp}
                          className="me-2 "
                        />
                        {appsetup.contactno}
                      </a>
                    </div>
                  )}
                  {appsetup.email && (
                    <div>
                      <a
                        href={`mailto:${appsetup.email}`}
                        className="contact_text"
                        onClick={handleCloseMobile}
                      >
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="me-2 "
                        />
                        {appsetup.email}
                      </a>
                    </div>
                  )}
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>
    </section>
  );
};

export default Header;
